// extracted by mini-css-extract-plugin
module.exports = {"UserGroupsExportModal":"x8QUOUyA","modalContent":"lpcTA298"};